import Vue from "vue/dist/vue.esm";
import NpsSurvey from "components/nps-survey";
import trackEvent from "modules/track-event";
import getWindowDimensions from "modules/get-window-dimensions";
import axios from "axios";
import { getCookie, setCookie } from "modules/cookie";
import { notify } from "modules/notify";
import Sentry from "modules/sentry";

const NPS_SURVEY_SEEN_COOKIE = "nps";
const $npsSurveyContainer = document.querySelector(".js-nps-survey");

const seenNpsSurvey = getCookie(NPS_SURVEY_SEEN_COOKIE);

if(!seenNpsSurvey && $npsSurveyContainer && getWindowDimensions().width > 720) {
  axios.get("/api/nps_scores/check").then(response => {
    if(response.data.show_nps_score) {
      new Vue({
        el: $npsSurveyContainer,
        render: h => h(NpsSurvey)
      });

      trackEvent("GAEvent", {
        category: "nps_survey",
        action: "show"
      });
    }

    setCookie(NPS_SURVEY_SEEN_COOKIE, true, 14);
  }).catch(function (error) {
    Sentry.captureException(error);

    notify({
      message: "Smth went wrong",
      type: "error"
    });
  });
}
